module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-ru.77281bd1c88eeaea4a1e.svg";